import Component from './ChangePassword';

export default Component;
